import { useQuery } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useBalance = () => {
  const query = useQuery({
    queryKey: [QueryKeys.BALANCE],
    queryFn: () => paymentRepo.getBalance(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseBalance = ReturnType<typeof useBalance>;
